import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiDelete, operationsClient } from '@/lib/api/client';
import { taxCodeEndpoints } from '@/lib/api/endpoints';
import { taxGroupKeys, taxRateKeys, taxZoneKeys } from '@/lib/queryKeys';

export const useDeleteTaxRate = createMutationHook<void, string>({
  mutationFn: (id) => apiDelete<void>(operationsClient, taxCodeEndpoints.delete(id)),
  onSuccess: (_data, id, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: taxRateKeys.all() });
    void queryClient.invalidateQueries({ queryKey: taxZoneKeys.all() });
    void queryClient.invalidateQueries({ queryKey: taxGroupKeys.all() });
    queryClient.removeQueries({ queryKey: taxRateKeys.detail(id) });
    toast.success('Tax rate deleted');
  },
});
